export default __webpack_public_path__ + "static/media/illustration_become_partner.58d0b074.svg";